import { Box, IconButton, Typography, styled, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import List from 'components/list/list';
import Tooltip from 'components/tooltip';

import { ReactComponent as CopyIcon } from '../assets/copy.svg';
import LoadingSpinner from 'components/loading-spinner';
import { useSiteSettingsState } from 'views/site-settings/context/site-settings-context';

type Props = {};

const StyledList = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 8,
  gap: 16,
  borderRadius: 8,
  padding: 8,
  background: theme.palette.common.white,
}));

const PAGE_NAME_ID = 'siteSettings.editSiteSettings';

const SiteContactNumbers: React.FC<Props> = ({}) => {
  const theme = useTheme();

  const {
    siteSettingsQuery: { data: settings, isLoading },
  } = useSiteSettingsState();

  if (isLoading) return <LoadingSpinner />; // bad solution?
  if (!settings) return <></>;

  const contactNumbers = useMemo(() => settings.phoneNumbers, [settings]);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Typography sx={{ mb: { xs: 0 } }} variant="h3" color={theme.palette.common.white}>
          <FormattedMessage id={`${PAGE_NAME_ID}.phoneNumbers`} />
        </Typography>
      </Box>
      <List
        noResult={{
          show: !contactNumbers.length,
          text: <FormattedMessage id={`siteSettings.listSites.list.noResults`} />,
        }}>
        {contactNumbers.map((number, idx) => {
          return (
            <StyledList key={`${idx}_${number}`}>
              <Typography
                color={theme.palette.common.black}
                noWrap
                sx={{ textTransform: 'lowercase', textAlign: 'left', pl: 2, maxWidth: { xs: 270, md: 480 } }}
                variant="body2">
                {number}
              </Typography>
              <Tooltip title="Copy to clipboard">
                <IconButton onClick={() => navigator.clipboard.writeText(number)}>
                  <CopyIcon fontSize={32} color={theme.palette.darkBlue.contrastText} />
                </IconButton>
              </Tooltip>
            </StyledList>
          );
        })}
      </List>
    </>
  );
};

export default SiteContactNumbers;
